import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/app/projects/page-client.tsx");
